var map = {
	"./01.jpg": "af7e",
	"./01b.jpg": "92ae",
	"./02.jpg": "a795",
	"./02b.jpg": "7d6a",
	"./03.jpg": "8209",
	"./03b.jpg": "d71e",
	"./04.jpg": "8976",
	"./04b.jpg": "5718",
	"./05.jpg": "2a44",
	"./05b.jpg": "7539",
	"./06.jpg": "b1ee",
	"./06b.jpg": "5304",
	"./07.jpg": "6208",
	"./07b.jpg": "7981",
	"./08.jpg": "d98d",
	"./08b.jpg": "68d5",
	"./09.jpg": "3fc7",
	"./09b.jpg": "884a",
	"./10.jpg": "b82b",
	"./10b.jpg": "e0c0",
	"./11.jpg": "3c22",
	"./11b.jpg": "6c6a",
	"./12.jpg": "c924",
	"./12b.jpg": "bd63",
	"./13.jpg": "031f",
	"./13b.jpg": "447e",
	"./14.jpg": "17db",
	"./14b.jpg": "1fe5",
	"./15.jpg": "014d",
	"./15b.jpg": "e333",
	"./16.jpg": "794d4",
	"./16b.jpg": "ab27",
	"./17.jpg": "cf40",
	"./17b.jpg": "a678",
	"./18.jpg": "bd9f",
	"./18b.jpg": "f231",
	"./19.jpg": "777b",
	"./19b.jpg": "1739",
	"./20.jpg": "77ec",
	"./20b.jpg": "b3a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "48fc";